import { IDENTITY_LIFECYCLE_SIGNALS } from "./events";

/** Maps lifecycle signals to minimum stage index (STAGE_0 = 0 … STAGE_8 = 8). */
export const IDENTITY_LIFECYCLE_ADVANCE_RULES = {
	[IDENTITY_LIFECYCLE_SIGNALS.marketingResonateEngage]: 2,
	[IDENTITY_LIFECYCLE_SIGNALS.waitlistPageView]: 2,
	[IDENTITY_LIFECYCLE_SIGNALS.pricingView]: 3,
	[IDENTITY_LIFECYCLE_SIGNALS.highIntentCta]: 3,
	[IDENTITY_LIFECYCLE_SIGNALS.waitlistSignup]: 3,
	[IDENTITY_LIFECYCLE_SIGNALS.newsletterSignup]: 3,
	[IDENTITY_LIFECYCLE_SIGNALS.scheduleChatBooked]: 3,
	[IDENTITY_LIFECYCLE_SIGNALS.authSessionEstablished]: 4,
	[IDENTITY_LIFECYCLE_SIGNALS.onboardingCompleted]: 5,
	[IDENTITY_LIFECYCLE_SIGNALS.postOnboardingAppVisit]: 5,
} as const;

export function resolveLifecycleAdvanceStageIndex(
	signal: string,
): number | null {
	const index =
		IDENTITY_LIFECYCLE_ADVANCE_RULES[
			signal as keyof typeof IDENTITY_LIFECYCLE_ADVANCE_RULES
		];
	return index ?? null;
}
